module.exports = __webpack_public_path__ + "img/beer_id-10.c83e701c.png";